/**
 * Lynden Category v2 — filter toolbar + ATC (DEV preview)
 */
(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function moneyFromDataset(cents, format) {
    // Shopify money is already rendered on cards; this is only for ATC feedback.
    return format || "";
  }

  /**
   * Preserve original collection SEO HTML (lyd-coll-top / lyd-coll-bot).
   * Top sits above the product grid; bottom (FAQ, tables, compliance) below.
   */
  function placeCollectionCms(root) {
    var source = qs("[data-cv2-desc-source]", root);
    var topHost = qs("[data-cv2-coll-top]", root);
    var botHost = qs("[data-cv2-coll-bot]", root);
    if (!source || source.dataset.cv2CmsDone === "1") return;
    source.dataset.cv2CmsDone = "1";

    // Move embedded <style> into document head (once) so rules still apply
    qsa("style", source).forEach(function (st) {
      if (st.dataset.cv2StyleMoved) return;
      st.dataset.cv2StyleMoved = "1";
      var clone = st.cloneNode(true);
      clone.setAttribute("data-lyd-cv2-cms-style", "1");
      document.head.appendChild(clone);
      st.parentNode.removeChild(st);
    });

    var top = qs(".lyd-coll-top", source);
    var bot = qs(".lyd-coll-bot", source);

    if (top && topHost) {
      topHost.appendChild(top);
      topHost.hidden = false;
    }
    if (bot && botHost) {
      botHost.appendChild(bot);
      botHost.hidden = false;
    }

    // Fallback: unstructured description → full body below grid
    if (!top && !bot && botHost) {
      // move remaining children
      while (source.firstChild) {
        botHost.appendChild(source.firstChild);
      }
      botHost.hidden = false;
    } else {
      // any leftover nodes (rare) → bottom
      if (botHost && source.childNodes.length) {
        while (source.firstChild) {
          botHost.appendChild(source.firstChild);
        }
      }
    }

    source.hidden = true;
  }

  function initRoot(root) {
    if (!root || root.dataset.cv2Ready) return;
    root.dataset.cv2Ready = "1";

    placeCollectionCms(root);

    var kind = root.dataset.defaultKind || "m";
    var cat = "all";
    var series = "all";
    var seg = qs("[data-cv2-seg]", root);
    var chips = qs("[data-cv2-chips]", root);
    var seriesBar = qs("[data-lyd-series-filter]", root);
    var countEl = qs("[data-cv2-count]", root);
    var emptyEl = qs("[data-cv2-empty]", root);
    var cards = qsa("[data-cv2-card]", root);
    var kindLabels = {
      m: root.dataset.labelKindM || "Sorten",
      p: root.dataset.labelKindP || "Sorten",
    };

    /** Only filter by kind when the M/P segment control is actually active */
    function kindFilterActive() {
      if (!seg) return false;
      if (seg.getAttribute("aria-hidden") === "true") return false;
      if (seg.style && seg.style.display === "none") return false;
      return qsa("button[data-kind]", seg).length > 1;
    }

    /**
     * Flavor chips (Frucht / Ice / …): only show categories that exist on cards.
     * Hide the whole chip bar if nothing useful remains.
     * Product grids set data-cv2-flavor-on="0" — never show chips there.
     */
    function syncFlavorChips() {
      if (!chips) return;
      if (chips.getAttribute("data-cv2-flavor-on") !== "1") {
        chips.style.display = "none";
        chips.setAttribute("aria-hidden", "true");
        cat = "all";
        return;
      }
      var present = {};
      cards.forEach(function (card) {
        var cc = card.getAttribute("data-cat") || "";
        if (cc) present[cc] = (present[cc] || 0) + 1;
      });

      var visibleCats = 0;
      qsa("button[data-cat]", chips).forEach(function (btn) {
        var c = btn.getAttribute("data-cat") || "";
        if (c === "all") {
          btn.hidden = false;
          return;
        }
        var ok = !!present[c];
        btn.hidden = !ok;
        if (ok) visibleCats += 1;
      });

      // No flavor taxonomy in this grid → hide chips entirely
      if (visibleCats === 0) {
        chips.style.display = "none";
        chips.setAttribute("aria-hidden", "true");
        cat = "all";
      } else {
        chips.style.display = "";
        chips.removeAttribute("aria-hidden");
        // if current cat vanished, reset
        if (cat !== "all" && !present[cat]) {
          cat = "all";
          qsa("button[data-cat]", chips).forEach(function (b) {
            b.classList.toggle("on", b.getAttribute("data-cat") === "all");
          });
        }
      }
    }

    /** Only filter by flavor chips when chip bar is active */
    function catFilterActive() {
      if (!chips) return false;
      if (chips.getAttribute("aria-hidden") === "true") return false;
      if (chips.style && chips.style.display === "none") return false;
      if (chips.hidden) return false;
      return qsa("button[data-cat]:not([hidden])", chips).length > 1;
    }

    function seriesFilterActive() {
      return !!(seriesBar && qsa("button[data-series]", seriesBar).length > 1);
    }

    function apply() {
      var n = 0;
      var useKind = kindFilterActive();
      var useCat = catFilterActive();
      var useSeries = seriesFilterActive();
      cards.forEach(function (card) {
        var ck = card.getAttribute("data-kind") || "";
        var cc = card.getAttribute("data-cat") || "frucht";
        var cs = (card.getAttribute("data-series") || "core").toLowerCase();
        var show =
          (!useKind || !kind || ck === kind) &&
          (!useCat || cat === "all" || cc === cat) &&
          (!useSeries || series === "all" || cs === series);
        card.classList.toggle("is-hidden", !show);
        if (show) n += 1;
      });
      if (countEl) {
        var label = useKind ? kindLabels[kind] || "Artikel" : "Artikel";
        countEl.textContent = n + " " + label;
      }
      if (emptyEl) emptyEl.classList.toggle("is-show", n === 0);
    }

    // Initial chip visibility from full card set
    syncFlavorChips();

    if (seg) {
      qsa("button[data-kind]", seg).forEach(function (btn) {
        btn.addEventListener("click", function () {
          kind = btn.getAttribute("data-kind") || "m";
          qsa("button[data-kind]", seg).forEach(function (b) {
            b.classList.toggle("on", b === btn);
          });
          // Re-evaluate which flavor chips exist for this kind
          // Temporarily clear kind-hide to recount cats within kind
          cards.forEach(function (card) {
            var ck = card.getAttribute("data-kind") || "";
            var inKind = !kind || ck === kind;
            card.classList.toggle("is-hidden", !inKind);
          });
          // recount cats only among kind-visible cards
          if (chips) {
            var present = {};
            cards.forEach(function (card) {
              if (card.classList.contains("is-hidden")) return;
              var cc = card.getAttribute("data-cat") || "";
              if (cc) present[cc] = true;
            });
            var visibleCats = 0;
            qsa("button[data-cat]", chips).forEach(function (b) {
              var c = b.getAttribute("data-cat") || "";
              if (c === "all") {
                b.hidden = false;
                return;
              }
              var ok = !!present[c];
              b.hidden = !ok;
              if (ok) visibleCats += 1;
            });
            if (visibleCats === 0) {
              chips.style.display = "none";
              chips.setAttribute("aria-hidden", "true");
              cat = "all";
            } else {
              chips.style.display = "";
              chips.removeAttribute("aria-hidden");
              if (cat !== "all" && !present[cat]) {
                cat = "all";
                qsa("button[data-cat]", chips).forEach(function (b) {
                  b.classList.toggle("on", b.getAttribute("data-cat") === "all");
                });
              }
            }
          }
          apply();
        });
      });
    }

    if (chips) {
      qsa("button[data-cat]", chips).forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (btn.hidden) return;
          cat = btn.getAttribute("data-cat") || "all";
          qsa("button[data-cat]", chips).forEach(function (b) {
            b.classList.toggle("on", b === btn);
          });
          apply();
        });
      });
    }

    /* Brand series chips (e.g. Pod Salt: Alle · Core · X · Origin · NexLiq) */
    if (seriesBar) {
      qsa("button[data-series]", seriesBar).forEach(function (btn) {
        btn.addEventListener("click", function () {
          series = (btn.getAttribute("data-series") || "all").toLowerCase();
          qsa("button[data-series]", seriesBar).forEach(function (b) {
            b.classList.toggle("is-active", b === btn);
            b.classList.toggle("on", b === btn);
          });
          apply();
          var grid = qs("#lyd-cv2-sortiment", root) || qs("[data-cv2-gridsec]", root);
          if (grid && series !== "all") {
            try {
              grid.scrollIntoView({ behavior: "smooth", block: "start" });
            } catch (e) {}
          }
        });
      });
    }

    // Class-card jumps
    qsa("[data-cv2-seg-to]", root).forEach(function (el) {
      el.addEventListener("click", function (e) {
        var k = el.getAttribute("data-cv2-seg-to");
        if (!k) return;
        e.preventDefault();
        kind = k;
        if (seg) {
          qsa("button[data-kind]", seg).forEach(function (b) {
            b.classList.toggle("on", b.getAttribute("data-kind") === k);
          });
        }
        apply();
        var grid = qs("#lyd-cv2-sortiment", root) || qs("[data-cv2-gridsec]", root);
        if (grid) grid.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    // ATC
    qsa("[data-cv2-atc]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.disabled) return;
        var vid = btn.getAttribute("data-variant-id");
        if (!vid) return;
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = "…";
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error("add failed");
            return r.json();
          })
          .then(function () {
            btn.textContent = "Hinzugefügt";
            document.dispatchEvent(new CustomEvent("cart:refresh"));
            document.dispatchEvent(new CustomEvent("product-added-to-cart"));
            // Wave 1: cart drawer hidden — go to full cart page
            window.location.href = "/cart";
          })
          .catch(function () {
            btn.textContent = "Fehler";
            setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
            }, 1500);
          });
      });
    });

    apply();
  }

  function boot() {
    qsa(".lyd-cv2").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
